import {ICategoryList} from '../core/_model'
import {useMutation, useQueryClient} from 'react-query'
import {BASE_URL} from '../../config'
import axios from 'axios'
import toast from 'react-hot-toast'
import {KTIcon} from '../../../../_metronic/helpers'

type Props = {
  selectedCategory: ICategoryList | null
  onDeselectCategory: () => void
}

const DELETE_CATGORY_URL = `${BASE_URL}/api/protect/deleteCategory`

const DeleteCategory = ({selectedCategory, onDeselectCategory}: Props) => {
  const queryClient = useQueryClient()

  const onClose = () => onDeselectCategory()

  const {mutate: deleteCategory} = useMutation({
    mutationKey: ['category'],
    mutationFn: async () => {
      toast.loading('Processing..')
      const response = await axios.delete(`${DELETE_CATGORY_URL}/${selectedCategory?.id}`)
      console.log(response)
    },
    onSuccess: () => {
      toast.dismiss()
      queryClient.invalidateQueries(['category'])
      toast.success('Deleted Successfully')
      onClose()
    },
  })

  const onDelete = async () => {
    await deleteCategory()
  }

  return (
    <div className='modal fade' tabIndex={-2} id='kt_modal_2'>
      {/* begin::Modal dialog */}
      <div className='modal-dialog modal-dialog-centered modal-md p-12'>
        {/* begin::Modal content */}
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title fs-2'>Delete Category</h5>
            <div
              className='btn btn-icon btn-sm btn-active-light-primary ms-2'
              data-bs-dismiss='modal'
              aria-label='Close'
              onClick={onClose}
            >
              <KTIcon iconName='cross' className='fs-1' />
            </div>
          </div>
          {/* begin::Modal body */}
          <div className='modal-body scroll-y my-5 mx-10'>
            {selectedCategory ? (
              <>
                <p className='fs-4 fw-semibold text-danger text-center m-0'>
                  Are you sure? <br />
                </p>
                <p className='fs-4 fw-semibold text-danger text-center'>
                  You want to delete {selectedCategory.category_name}? <br />
                </p>

                <div className='text-center pt-15'>
                  <button
                    type='reset'
                    className='btn btn-light me-3'
                    data-kt-users-modal-action='cancel'
                    data-bs-dismiss='modal'
                    aria-label='Close'
                    onClick={onClose}
                  >
                    Discard
                  </button>

                  <button
                    type='submit'
                    className='btn btn-danger'
                    data-kt-users-modal-action='submit'
                    data-bs-dismiss='modal'
                    aria-label='Close'
                    onClick={onDelete}
                  >
                    <span className='indicator-label'>Delete</span>
                  </button>
                </div>
              </>
            ) : (
              <p className='fs-4 fw-semibold text-center'>Loading..</p>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default DeleteCategory
